import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Search } from "../preguntasFrecuentes/Search";
import Glide from "@glidejs/glide";

export const PuestaADisposicion = props => {
    const [puesta, setpuesta] = useState([]);
    useEffect(() => {
        fetch("/puesta_dispo")
            .then(res => res.json())
            .then(result => {
                setpuesta(result);
            });
    }, []);
    // number es lo que recibimos del search
    const [number, setNumber] = useState("");

    let arregloDeArreglos = [];
    if (number == "") {
        if (puesta.length != 0) {
            for (let i = 0; i < puesta.length; i += 10) {
                let pedazo = puesta.slice(i, i + 10);
                arregloDeArreglos.push(pedazo);
            }
        }
    } else {
        let gruposEncontrados = puesta.filter(grupo => {
            return grupo.codigo.toString().includes(number);
        });

        if (gruposEncontrados.length != 0) {
            for (let i = 0; i < gruposEncontrados.length; i += 10) {
                let pedazo = gruposEncontrados.slice(i, i + 10);
                arregloDeArreglos.push(pedazo);
            }
        }
    }

    //esto se setea para saber en que breakpoint estamos y hacer el cambio en la descripcion que se muestran junto a la flechas de slider, grupo 1 a 70 de 100 por ejemplo
    const [size, setSize] = useState(window.innerWidth);
    window.addEventListener("resize", () => {
        setSize(window.innerWidth);
    });

    //parrafos se usa para poner el total de numeros que se muestran junto con las flechas de slider
    const [parrafos, setParrafos] = useState("");

    let calc = Math.round(parrafos / 10);

    const [perView, setperView] = useState("");

    useEffect(() => {
        if (size > 768) {
            if (calc >= 5) {
                setperView(5);
            } else {
                setperView(calc);
            }
        }

        if (size > 600 && size < 768) {
            if (calc >= 3) {
                setperView(3);
            } else {
                setperView(calc);
            }
        }

        if (size < 600) {
            setperView(1);
        }
    }, [size, calc]);

    const [hasta, sethasta] = useState("");
    const [desde, setdesde] = useState(1);

    useEffect(() => {
        let li = document.querySelectorAll(".sliderInfo--ul li");
        if (li.length > 1) {
            let newLi = [];

            for (let index = 0; index < perView; index++) {
                newLi.push(li[index]);
            }

            let child = 0;
            for (let index = 0; index < newLi.length; index++) {
                if (newLi[index] != undefined) {
                    child = child + newLi[index].children.length;
                }
            }
            sethasta(child);
        } else {
            sethasta(parrafos);
        }

        let p = document.querySelectorAll(".sliderInfo--ul li p");

        setParrafos(p.length);

        //slider

        let glides = document.querySelectorAll(".sliderInfo");

        for (var i = 0; i < glides.length; i++) {
            let glide = new Glide(glides[i], {
                gap: 0,
                animationDuration: 300,
                perView: calc >= 5 ? 5 : calc,
                bound: true,
                breakpoints: {
                    600: {
                        perView: 1
                    },
                    768: {
                        perView: calc >= 3 ? 3 : calc
                    },
                    992: {
                        perView: calc >= 5 ? 5 : calc
                    }
                }
            });

            glide.on("run", function(e) {
                const a = document.querySelector(".a");
                const de = document.querySelector(".de");

                //logica segun cada breakpoint del
                if (size < 600) {
                    a.innerHTML = glide.index * 10 + 10;
                    console.log(glide.index);
                    de.innerHTML = glide.index * 10 + 1;
                    if (glide.index == li.length - glide.settings.perView) {
                        a.innerHTML = parrafos;
                    }
                } else if (size > 600 && size < 768) {
                    a.innerHTML = glide.index * 10 + 30;
                    de.innerHTML = glide.index * 10 + 1;
                    if (glide.index == li.length - glide.settings.perView) {
                        a.innerHTML = parrafos;
                    }
                    if (hasta <= 10) {
                        de.innerHTML = 1;
                    }
                } else if (size > 768) {
                    a.innerHTML = glide.settings.perView * 10 + 10;
                    de.innerHTML = glide.index * 10 + 1;
                    if (glide.index == li.length - glide.settings.perView) {
                        a.innerHTML = parrafos;
                    }
                    if (hasta <= 10) {
                        de.innerHTML = 1;
                    }
                }
                if (glide.index == 0) {
                    de.innerHTML = 1;
                    a.innerHTML = hasta;
                }
            });

            glide.mount();
            return () => glide.destroy();
        }
    });

    console.log(arregloDeArreglos[0]);
    return (
        <div className="resultadosContainer">
            <div className="resultadosContainer--mainDiv">
                <div className="title">
                    <div className="title--container">
                        <Link to={"/informacion_general"}>
                            Información general
                        </Link>
                    </div>
                </div>
                <div className="subtitle">
                    <div className="subtitle--container">
                        <p className="ff-FuturaMedium">
                            Puesta a disposición de fondos
                        </p>
                    </div>
                </div>
            </div>

            <div className="slideInfo">
                <div className="slideInfo--container">
                    <Search setQuestion={setNumber} type="info" />
                    <div className="slideInfo--title">
                        <p>GRUPO</p>
                        <div className="separator--hor mt-half mb-octa"></div>
                    </div>
                    {number == "" && arregloDeArreglos.length != 0 && (
                        <div className="glide sliderInfo">
                            <div data-glide-el="track" className="glide__track">
                                <ul className="glide__slides sliderInfo--ul">
                                    {arregloDeArreglos.map(
                                        (arreglo, index) => (
                                            <li key={index}>
                                                {arreglo.map(
                                                    (arr, indexarr) => (
                                                        <p key={indexarr}>
                                                            {arr.codigo}
                                                        </p>
                                                    )
                                                )}
                                            </li>
                                        )
                                    )}
                                </ul>
                            </div>
                            <div className="separator--hor mt-half mb-octa"></div>
                            <div
                                className="glide__arrows sliderInfo--arrows"
                                data-glide-el="controls"
                            >
                                <button
                                    className="glide__arrow glide__arrow--left"
                                    data-glide-dir="<"
                                >
                                    <img src="/images/icons/arrow-left.svg" />
                                </button>
                                <div className="d-flex">
                                    Grupos{" "}
                                    <p className="de mb-0 mx-octa">{desde}</p> a{" "}
                                    <p className="a mb-0 mx-octa">{hasta}</p> de{" "}
                                    {parrafos}
                                </div>
                                <button
                                    className="glide__arrow glide__arrow--right"
                                    data-glide-dir=">"
                                >
                                    <img src="/images/icons/arrow-right.svg" />
                                </button>
                            </div>
                        </div>
                    )}

                    {number != "" && arregloDeArreglos.length != 0 && (
                        <div className="glide sliderInfo">
                            <div data-glide-el="track" className="glide__track">
                                <ul className="glide__slides sliderInfo--ul">
                                      {arregloDeArreglos.length != 0 &&
                                        arregloDeArreglos.map(
                                            (arreglo, index) => (
                                                <li key={index}>
                                                    {arreglo.map(
                                                        (arr, indexarr) => (
                                                            <p key={indexarr}>
                                                                {arr.codigo}
                                                            </p>
                                                        )
                                                    )}
                                                </li>
                                            )
                                        )} 
                                </ul>
                            </div>
                            <div className="separator--hor mt-half mb-octa"></div>
                            <div
                                className="glide__arrows sliderInfo--arrows"
                                data-glide-el="controls"
                            >
                                <button
                                    className="glide__arrow glide__arrow--left"
                                    data-glide-dir="<"
                                >
                                    <img src="/images/icons/arrow-left.svg" />
                                </button>
                                <div className="d-flex">
                                    Grupos{" "}
                                    <p className="de mb-0 mx-octa">{desde}</p> a{" "}
                                    <p className="a mb-0 mx-octa">{hasta}</p> de{" "}
                                    {parrafos}
                                </div>
                                <button
                                    className="glide__arrow glide__arrow--right"
                                    data-glide-dir=">"
                                >
                                    <img src="/images/icons/arrow-right.svg" />
                                </button>
                            </div>
                        </div>
                    )}
                    {arregloDeArreglos.length == 0 && number != "" && (
                        <p>No se encontraron grupos relacionados.</p>
                    )}
                    {arregloDeArreglos.length == 0 && number == "" && (
                        <p>Por el momento no hay grupos liquidados.</p>
                    )}
                </div>
            </div>
        </div>
    );
};
